import React, { useState, useEffect } from "react"; // Assurez-vous que tous les hooks sont importés
import { ShieldCheck } from "lucide-react";

import { useNavigate } from 'react-router-dom';
import { useAuth } from '../components/AuthContext'; 

const Login = () => {
    const [username, setUsername] = useState(""); 
    const [password, setPassword] = useState("");
    const [error, setError] = useState(""); 

    const { isLoggedIn, login } = useAuth();
    const navigate = useNavigate();

    // ✅ CORRECTION MAJEURE: Utiliser useEffect pour la redirection.
    // Cette fonction ne s'exécute qu'après que le composant a été rendu (monté), 
    // ce qui évite de déclencher un setState pendant le rendu.
    useEffect(() => {
        if (isLoggedIn) {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoggedIn, navigate]); // S'exécute quand isLoggedIn change.

    // Retourne un écran de chargement si l'utilisateur est déjà connecté, 
    // en attendant que le useEffect le redirige.
    if (isLoggedIn) {
        return (
            <div className="min-h-screen flex items-center justify-center text-gray-700 bg-gradient-to-b from-[#f4f7ff] to-[#e9f0ff]">
                Redirection vers le tableau de bord...
            </div>
        );
    }

    const handleLogin = (e) => {
        e.preventDefault();
        setError("");

        const success = login(username, password);

        if (success) {
            // Le changement de isLoggedIn déclenchera le useEffect ci-dessus,
            // qui gérera la navigation.
            navigate("/dashboard", { replace: true });
        } else {
            setError("Invalid credentials. Please use one of the test accounts.");
            setPassword("");
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#f4f7ff] to-[#e9f0ff] px-4">
            <div className="bg-white rounded-2xl shadow-xl p-10 max-w-md w-full text-center">
                
                {/* Logo */}
                <div className="flex justify-center mb-6">
                    <div className="bg-black text-white p-3 rounded-full">
                        <ShieldCheck className="w-8 h-8" />
                    </div>
                </div>

                {/* Title */}
                <h1 className="text-2xl font-semibold text-gray-800">
                    Safewings Insurance
                </h1>
                <p className="text-gray-500 text-sm mt-2 mb-8">
                    Sign in to access your insurance management dashboard
                </p>

                {/* ERROR MESSAGE DISPLAY */}
                {error && (
                    <div className="p-3 mb-4 text-sm font-medium text-red-700 bg-red-100 border border-red-300 rounded-lg">
                        {error}
                    </div>
                )}

                {/* Form */}
                <form onSubmit={handleLogin} className="space-y-5 text-left">
                    <div>
                        <label className="text-sm font-medium text-gray-700 block mb-1">
                            Username
                        </label>
                        <input
                            type="text"
                            placeholder="e.g., admin, agent, or manager"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black outline-none bg-gray-50"
                        />
                    </div>

                    <div>
                        <label className="text-sm font-medium text-gray-700 block mb-1">
                            Password
                        </label>
                        <input
                            type="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-black outline-none bg-gray-50"
                        />
                    </div>

                    <button
                        type="submit"
                        className="w-full bg-black text-white py-2 rounded-lg font-medium hover:bg-gray-800 transition"
                    >
                        Sign In
                    </button>
                </form>

                {/* Demo credentials */}
                <p className="text-xs text-gray-500 mt-6">
                    Demo credentials (defined in AuthContext.jsx): <br />
                    <b>admin</b> / <b>password123</b> <br />
                    <b>agent</b> / <b>password123</b>
                </p>
            </div>
        </div>
    );
};

export default Login;